// Registrars + Route Builder
import {
    AdUnitRegistration,
    AFLDraftHeaderRegistration,
    AflFixturesScoreboardWidgetRegistration,
    AflFixturesWidgetRegistration,
    AflInjuriesSuspensionsWidgetRegistration,
    AflMatchLadderWidgetRegistration,
    AflMatchStatsWidgetRegistration,
    AflMatchSummaryWidgetRegistration,
    AflPlayerStatsWidgetRegistration,
    AflScoreBoardRegistration,
    AflSquadsWidgetRegistration,
    AmpGoogleAnalyticsFourRegistration,
    AmpSophiRegistration,
    AmpStickyAdUnitRegistration,
    ArticleHeroRegistration,
    AthenaRegistration,
    BoxRegistration,
    BreachScreenRegistration,
    BreadcrumbRegistration,
    BreakingNewsRegistration,
    BusinessDevelopingNewsRegistration,
    CerberusFourRegistration,
    CerberusRegistration,
    ComingSoonRegistration,
    CommonwealthGamesMedalTallyWidgetRegistration,
    ComponentRendererErrorRegistration,
    ContentSeparatorRegistration,
    CookieConsentUserSettingsPageRegistration,
    CoralRegistration,
    CuratedPromotionalCardRegistration,
    DevelopingNewsRegistration,
    DoubletRegistration,
    ElectionFilterContextRegistration,
    ePaperPageLatestEditionRegistration,
    ePaperPageReadersAlsoLoveRegistration,
    ePaperPageRegistration,
    PuzzlesPageRegistration,
    FactCheckerSectionHeaderRegistration,
    FailLoadContent404Registration,
    FailLoadContentRegistration,
    FeatureArticleBreachCompositionRegistration,
    FeatureCompositionRegistration,
    FeatureHeadlineRegistration,
    FederalElectionAccordionRegistration,
    FederalElectionWidgetCollectionRegistration,
    FigCaptionRegistration,
    FlourishIframeRegistration,
    FullElectorateWidgetRegistration,
    GenericInArticleBannerRegistration,
    getComponentOverriderRegistration,
    getSchemeOverriderRegistration,
    GuestBookRegistration,
    HeadlineRegistration,
    HeadToHeadSeatCountWidgetRegistration,
    HeraRegistration,
    HorizontalCricketWidgetRegistration,
    IframeRegistration,
    ImageBannerRegistration,
    InlineContentRegistration,
    JanusRegistration,
    JulietRegistration,
    LimaRegistration,
    LinkBannerRegistration,
    LiveScoresRegistration,
    MapOverviewWidgetRegistration,
    MatchTimelineWidgetRegistration,
    MedalTallyRegistration,
    NewsletterSignupRegistration,
    NovemberRegistration,
    OlympicsCollectionRegistration,
    OmnyRegistration,
    OscarRegistration,
    OurPublicationRegistration,
    PaperPromoRegistration,
    ParagraphRegistration,
    PartyTotalsRegistration,
    PodcastIntroTileRegistration,
    PodcastSubscribeRegistration,
    PollieRaterBannerRegistration,
    PollieRaterDriverBannerRegistration,
    PollieRaterInArticleBannerRegistration,
    PollieRaterRegistration,
    PortraitRegistration,
    ProfileCardRegistration,
    ProfileRegistration,
    PromoCardRegistration,
    PromoStrapRegistration,
    PromotionalCardRegistration,
    PublicationRelatedContentRegistration,
    PuzzleIframeRegistration,
    PuzzlesListingRegistration,
    QuickLinksRegistration,
    RedirectorRegistration,
    RegionalsSwgPromoPageRegistration,
    RelatedContentRegistration,
    RippleRegistration,
    SearchRegistration,
    SeatEmbedWidgetCollectionRegistration,
    SeatEmbedWidgetRegistration,
    SeatWidgetRegistration,
    SectionHeaderRegistration,
    SharingRegistration,
    ShorthandBreachCompositionRegistration,
    ShorthandPublicationRegistration,
    SierraRegistration,
    StaticContentRegistration,
    StaticMadMondayPromoCardRegistration,
    StaticSubscribePromoCardRegistration,
    StaticSubscribeVcPromoCardRegistration,
    StaticTradingUpPromoCardRegistration,
    TaboolaRegistration,
    TabRegistration,
    TelethonCountdownRegistration,
    TheRaceWidgetRegistration,
    TheSwingWidgetRegistration,
    TheWestArticleHeaderRegistration,
    TheWestArticleRegistration,
    TheWestFeatureRegistration,
    TheWestGalleryRegistration,
    TheWestLiveBillboardRegistration,
    TheWestLivePlayerPageRegistration,
    TheWestPageIsUnavailableRegistration,
    TheWestPageNotFoundRegistration,
    TheWestSomethingWentWrongRegistration,
    TheWestTermsContentRegistration,
    TheWestThemeConfig,
    TheWestVideoHubRegistration,
    ThorRegistration,
    TimelineFeedWidgetRegistration,
    TopicListRegistration,
    TWElectionNavigationRegistration,
    UniformRegistration,
    UpgradeAppRegistration,
    VideoHubRegistration,
    VideoTrailerCardRegistration,
    WebStoriesRegistration,
    WhiskeyRegistration,
    ZeusRegistration,
} from '@news-mono/component-library'
import {
    componentFeatureToggleMiddleware,
    componentOnEventMiddleware,
    ComponentServices,
    getDataLoaderMiddleware,
    requireEntitlementsMiddleware,
} from '@news-mono/web-common'
import { LayoutRegistration } from '@west-australian-newspapers/json-react-layouts'
import { RSSFeedsRegistration } from './routes/static/RSS/RSS.routing'

// Register Components & Collections
export const layout = LayoutRegistration<ComponentServices>()
    .registerComponents((registrar) =>
        registrar
            .registerComponent(ComponentRendererErrorRegistration)
            .registerComponent(FailLoadContentRegistration)
            .registerComponent(FailLoadContent404Registration)

            // collections
            .registerComponent(JulietRegistration)
            .registerComponent(LimaRegistration)
            .registerComponent(SierraRegistration)
            .registerComponent(UniformRegistration)
            .registerComponent(OscarRegistration)
            .registerComponent(NovemberRegistration)
            .registerComponent(WhiskeyRegistration)
            .registerComponent(PortraitRegistration)

            // components
            .registerComponent(AdUnitRegistration)
            .registerComponent(AmpStickyAdUnitRegistration)
            .registerComponent(InlineContentRegistration)
            .registerComponent(TheWestArticleRegistration)
            .registerComponent(TheWestArticleHeaderRegistration)
            .registerComponent(TheWestGalleryRegistration)
            .registerComponent(TheWestFeatureRegistration)
            .registerComponent(StaticContentRegistration)
            .registerComponent(SectionHeaderRegistration)
            .registerComponent(BreakingNewsRegistration)
            .registerComponent(PromoStrapRegistration)
            .registerComponent(BreadcrumbRegistration)
            .registerComponent(SearchRegistration)
            .registerComponent(IframeRegistration)
            .registerComponent(PuzzleIframeRegistration)
            .registerComponent(ProfileRegistration)
            .registerComponent(TheWestPageNotFoundRegistration)
            .registerComponent(TheWestSomethingWentWrongRegistration)
            .registerComponent(TheWestPageIsUnavailableRegistration)
            .registerComponent(NewsletterSignupRegistration)
            .registerComponent(LinkBannerRegistration)
            .registerComponent(ImageBannerRegistration)
            .registerComponent(PromotionalCardRegistration)
            .registerComponent(ProfileCardRegistration)
            .registerComponent(ArticleHeroRegistration)
            .registerComponent(SharingRegistration)
            .registerComponent(FeatureHeadlineRegistration)
            .registerComponent(HeadlineRegistration)
            .registerComponent(FigCaptionRegistration)
            .registerComponent(TopicListRegistration)
            .registerComponent(QuickLinksRegistration)
            .registerComponent(TelethonCountdownRegistration)
            .registerComponent(OmnyRegistration)
            .registerComponent(RelatedContentRegistration)
            .registerComponent(ParagraphRegistration)
            .registerComponent(TaboolaRegistration)
            .registerComponent(RippleRegistration)
            .registerComponent(TheWestLiveBillboardRegistration)
            .registerComponent(PublicationRelatedContentRegistration)
            .registerComponent(ContentSeparatorRegistration)
            .registerComponent(CoralRegistration)
            .registerComponent(TheWestTermsContentRegistration)
            .registerComponent(PaperPromoRegistration)
            .registerComponent(HeraRegistration)
            .registerComponent(RegionalsSwgPromoPageRegistration)
            .registerComponent(PollieRaterRegistration)
            .registerComponent(PollieRaterBannerRegistration)
            .registerComponent(PollieRaterDriverBannerRegistration)
            .registerComponent(PollieRaterInArticleBannerRegistration)
            .registerComponent(RedirectorRegistration)
            .registerComponent(DevelopingNewsRegistration)
            .registerComponent(BusinessDevelopingNewsRegistration)
            .registerComponent(GuestBookRegistration)
            .registerComponent(ComingSoonRegistration)
            .registerComponent(FlourishIframeRegistration)
            .registerComponent(ePaperPageRegistration)
            .registerComponent(PuzzlesPageRegistration)
            .registerComponent(ePaperPageLatestEditionRegistration)
            .registerComponent(ePaperPageReadersAlsoLoveRegistration)
            .registerComponent(MedalTallyRegistration)
            .registerComponent(OlympicsCollectionRegistration)
            .registerComponent(ShorthandPublicationRegistration)

            //afl match centre
            .registerComponent(AflFixturesWidgetRegistration)
            .registerComponent(AflFixturesScoreboardWidgetRegistration)
            .registerComponent(AflInjuriesSuspensionsWidgetRegistration)
            .registerComponent(AflMatchLadderWidgetRegistration)
            .registerComponent(AflMatchStatsWidgetRegistration)
            .registerComponent(AflPlayerStatsWidgetRegistration)
            .registerComponent(AflScoreBoardRegistration)
            .registerComponent(AflSquadsWidgetRegistration)
            .registerComponent(MatchTimelineWidgetRegistration)
            .registerComponent(AflMatchSummaryWidgetRegistration)
            .registerComponent(TimelineFeedWidgetRegistration)

            // Promo cards
            .registerComponent(PromoCardRegistration)
            // These should all be moved into the single PromoCard component above, if possible
            .registerComponent(StaticSubscribePromoCardRegistration)
            .registerComponent(StaticSubscribeVcPromoCardRegistration)
            .registerComponent(StaticTradingUpPromoCardRegistration)
            .registerComponent(StaticMadMondayPromoCardRegistration)

            // internal west components
            .registerComponent(HorizontalCricketWidgetRegistration)
            .registerComponent(LiveScoresRegistration)
            .registerComponent(RSSFeedsRegistration)
            .registerComponent(VideoTrailerCardRegistration)
            .registerComponent(AFLDraftHeaderRegistration)
            .registerComponent(OurPublicationRegistration)
            .registerComponent(TheWestLivePlayerPageRegistration)
            .registerComponent(CookieConsentUserSettingsPageRegistration)
            .registerComponent(FactCheckerSectionHeaderRegistration)
            .registerComponent(FederalElectionWidgetCollectionRegistration)
            .registerComponent(GenericInArticleBannerRegistration)
            .registerComponent(VideoHubRegistration)
            .registerComponent(TheWestVideoHubRegistration)
            .registerComponent(PodcastIntroTileRegistration)
            .registerComponent(PodcastSubscribeRegistration)

            .registerComponent(UpgradeAppRegistration)
            .registerComponent(AmpSophiRegistration)
            .registerComponent(AmpGoogleAnalyticsFourRegistration)

            .registerComponent(PuzzlesListingRegistration)
            .registerComponent(BreachScreenRegistration)
            .registerComponent(CuratedPromotionalCardRegistration)
            .registerComponent(FederalElectionAccordionRegistration)
            .registerComponent(WebStoriesRegistration)

            // Election components
            .registerComponent(TheRaceWidgetRegistration)
            .registerComponent(SeatWidgetRegistration)
            .registerComponent(SeatEmbedWidgetRegistration)
            .registerComponent(SeatEmbedWidgetCollectionRegistration)
            .registerComponent(TWElectionNavigationRegistration)
            .registerComponent(FullElectorateWidgetRegistration)
            .registerComponent(PartyTotalsRegistration)
            .registerComponent(HeadToHeadSeatCountWidgetRegistration)
            .registerComponent(MapOverviewWidgetRegistration)
            .registerComponent(TheSwingWidgetRegistration)
            .registerComponent(CommonwealthGamesMedalTallyWidgetRegistration)

            .registerMiddleware(componentFeatureToggleMiddleware)
            .registerMiddleware(getDataLoaderMiddleware('component'))
            .registerMiddleware(componentOnEventMiddleware)
            .registerMiddleware(requireEntitlementsMiddleware),
    )
    .registerCompositions((registrar) =>
        registrar
            .registerComposition(AthenaRegistration)
            .registerComposition(ZeusRegistration)
            .registerComposition(ThorRegistration)
            .registerComposition(BoxRegistration)
            .registerComposition(CerberusRegistration)
            .registerComposition(CerberusFourRegistration)
            .registerComposition(JanusRegistration)
            .registerComposition(TabRegistration)
            .registerComposition(DoubletRegistration)
            .registerComposition(FeatureCompositionRegistration)
            .registerComposition(FeatureArticleBreachCompositionRegistration)
            .registerComposition(ShorthandBreachCompositionRegistration)
            .registerComposition(ElectionFilterContextRegistration)
            .registerComposition(
                getSchemeOverriderRegistration<TheWestThemeConfig>(),
            )
            .registerComposition(
                getComponentOverriderRegistration<TheWestThemeConfig>(),
            )
            .registerMiddleware(componentFeatureToggleMiddleware)
            .registerMiddleware(getDataLoaderMiddleware('composition'))
            .registerMiddleware(componentOnEventMiddleware)
            .registerMiddleware(requireEntitlementsMiddleware),
    )
